// UI COMPONENTS
import { Button, Dropdown, Form, Modal, Table, Row, Col, Container } from "react-bootstrap";
import nodata from "../../../Utils/assets/img/leads_no_data_found.png"
// HOOKS & ICONS
import { resolvePath, useNavigate } from "react-router-dom";
import { BsArrowLeft, BsPencil, BsSearch, BsTrash, BsInfoCircle } from "react-icons/bs";
import { Controller, useForm } from "react-hook-form";
// VALIDATION
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
// HELPERS
import { formatDate, useDebounce } from "../../../Utils/helpers/commonhelper";

import { toast } from "sonner";
//css file
import "../productService/ProductServices.css"
import { TableSkeleton } from "../../../Utils/skeletonLoader/TableSkeleton";
// API handlers
import {
    DeleteRequest,
    GetRequest,
    PostRequest,
    PutRequest,
} from "../../../Utils/hooks/ApiHandler";
import DeleteModal from "../../DeleteModal";
import useLocalStorageState from "use-local-storage-state";

import { useEffect, useMemo, useRef, useState, useTransition } from "react";
import Select from 'react-select'
import { IconCircleX, IconHierarchy3, IconLayout2, IconListDetails, IconPlus } from "@tabler/icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { ChevronDown } from "lucide-react";
import { useGetRequest } from "../../../Utils/hooks/QueryHandler"
import { TreeView } from "./TreeView";
import { useOutsideClickHandler } from "../../../Utils/hooks/useOutsideClickHandler";

//Form validation schema using Zod
const baseAccountSchema = z.object({
    account_type: z.string().min(1, "Account Type is Required !"),
    account_name: z.string().min(1, "Account Name is Required !"),
    parent_id: z.string().optional(),
    account_code: z.string().optional(),
    description: z.string().optional(),
});

// Bank-specific fields schema
const bankFieldsSchema = z.object({
    account_number: z.string().min(1, "Account Number is Required !"),
    ifsc: z.string().min(1, "IFSC Code is Required !"),
    currency_id: z.string().optional(),
    // location: z.string().optional(),
    bank_name: z.string().min(1, "Bank Name is Required !")
});

// Function to create dynamic schema based on account type
const createAccountSchema = (accountType) => {
    if (accountType?.toLowerCase() === 'bank') {
        return baseAccountSchema.merge(bankFieldsSchema);
    }
    return baseAccountSchema;
};

export const Chart = () => {
    //  Getting customer info from session storage
    const [customer, setCustomer] = useLocalStorageState("customer");

    // state for modal opening of create charts account
    const [createAcc, setCreateAcc] = useState(false)
    //  Local states for managing designation data, errors, and loading state
    const navigate = useNavigate();

    //Auth headers for API requests
    const customerId = customer?.customer_details?.customer_id;
    const userID = customer?.customer_details?.id;

    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = {
        authentication: rf,
        Authorization: token,
    };

    const extras = { customer, setCustomer, rf, navigate };

    const [accounts, setAccounts] = useState([])
    const [account_options, setAccOptions] = useState([])
    // delete modal loading state
    const [loading, setLoading] = useState(false)

    // curr view for tree and list toggling
    const [currView, setCurrView] = useState("tree")

    const [selectedItem, setSelectedItem] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const containerRef = useRef(null);

    // loading state when account are fetched
    const [isLoading, setIsLoading] = useState(false)

    // state for showing loader on create or update
    const [isCreating, setIsCreating] = useState(false)
    // state for products all fields
    const [allProducts, setAllProducts] = useState(null)
    // state for parent account options
    const [parent_options, setParentOptions] = useState([])


    // master permissions 
    const permission = customer.customer_details?.permission;
    const user_type = Number(customer.customer_details?.user_type)
    const settingsPermission = permission?.filter(c => c.module_name === "setting")
    // view permission for master 
    const masterGrant = {
        isView: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.view)) : true,
        isCreate: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.create)) : true,
        isEdit: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.edit)) : true,
        isDelete: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.delete)) : true,
    }

    // Custom option component for better formatting (optional)
    const CustomOption = ({ innerRef, innerProps, data, isSelected, isFocused }) => (
        <div
            ref={innerRef}
            {...innerProps}
            style={{
                padding: '8px 12px',
                backgroundColor: isSelected
                    ? '#2684ff' // React Select's default blue
                    : isFocused
                        ? '#deebff' // Light blue on hover
                        : 'transparent',
                color: isSelected ? '#fff' : '#212529',
                cursor: 'pointer',
                transition: 'background-color 0.15s ease-in-out',
                borderRadius: '0',
                fontSize: '14px',
                lineHeight: '1.25',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                minHeight: '38px',
                boxSizing: 'border-box',
                userSelect: 'none',
                WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div style={{
                    fontWeight: '400',
                    color: isSelected ? '#fff' : '#212529',
                    fontSize: '14px',
                    lineHeight: '1.25'
                }}>
                    {data.label}
                </div>
                <div style={{
                    fontSize: '12px',
                    color: isSelected ? 'rgba(255, 255, 255, 0.8)' : '#6c757d',
                    lineHeight: '1.33',
                    marginTop: '2px'
                }}>
                    {data.account_code || 'No Code'}
                </div>
            </div>
        </div>
    );

    // delete modal state 
    const [showDeleteModal, setShowDeleteModal] = useState(false)


    const [currencyOpt, setCurrencyOpt] = useState([])

    //edit item id for edit modal
    const [editAccId, setEditAccId] = useState(null)

    // delete item id state
    const [deleteId, setDeleteId] = useState(null)
    const [isEditMode, setIsEditMode] = useState(false)

    // state for storing the acc type if its a bank acc then with respect to that the fields would get merged with the base schema
    const [accType, setAccType] = useState('')
    const finalSchema = createAccountSchema(accType)

    // debouncing for account number
    const [accountNo, setAccNo] = useState('')
    const [duplicateAccountNumMsg, setDuplicateAccountNumMsg] = useState(null)
    const debouncedAccountNumber = useDebounce(accountNo, 300)

    //React Hook Form setup
    const {
        register,
        watch,
        trigger,
        handleSubmit,
        setValue,
        reset,
        control,
        formState: { errors, validatingFields },
    } = useForm({
        resolver: zodResolver(isEditMode ? createAccountSchema(accType) : finalSchema),
    });

    // Filter options based on input
    const getFilteredOptions = () => {
        if (!inputValue.trim()) return account_options;

        return account_options.map(categoryObj => {
            const filtered = {};
            Object.entries(categoryObj).forEach(([label, accounts]) => {
                const filteredAccounts = accounts.filter(acc =>
                    acc.title.toLowerCase().includes(inputValue.toLowerCase())
                );
                if (filteredAccounts.length > 0) {
                    filtered[label] = filteredAccounts;
                }
            });
            return filtered;
        }).filter(categoryObj => Object.keys(categoryObj).length > 0);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (!isOpen && e.target.value) {
            setIsOpen(true);
        }
    };

    const selectItem = (item) => {
        setSelectedItem(item);
        setAccType(item.title)
        setValue("account_type", item.id)
        trigger('account_type');
        setInputValue('');
        setIsOpen(false);
        inputRef.current?.blur();
    };

    const clearSelection = () => {
        setSelectedItem(null);
        setInputValue('');
        setValue('account_type', null)
        inputRef.current?.focus();
    };

    // Close dropdown when clicking outside
    useOutsideClickHandler({
        objRef: containerRef,
        isDropdown: isOpen,
        setDropdown: setIsOpen
    })

    const filteredOptions = getFilteredOptions();
    async function checkDuplicate({
        validating_val,
        existing_val = ""
    }) {
        if (!validating_val || validating_val === existing_val) {
            return false // No value to check
        }
        try {
            const response = await GetRequest(`masters/checkDuplicateAccountNumber/${accountNo}/${customerId}`, { headers }, extras)
            if (response.status === "fail") {
                return;
            }
            return true
        } catch (error) {
            return false
        }
    }

    // useEffect for email duplication check
    useEffect(() => {
        const checkAccNum = async () => {
            if (debouncedAccountNumber) {
                setDuplicateAccountNumMsg(null)
                const isAccountNumberExisting = await checkDuplicate({ validating_val: debouncedAccountNumber })
                if (isAccountNumberExisting) {
                    setDuplicateAccountNumMsg("Account Number Already Exists!")
                }
            } else {
                setDuplicateAccountNumMsg(null)
            }
        }
        checkAccNum()
    }, [debouncedAccountNumber])

    // useeeffect for fetching currency value dropdown.
    useEffect(() => {
        (async () => {
            const res = await GetRequest(`deals/fetchActiveCurrency/${customerId}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                return
            }

            const currencyOptions = res.data && res.data?.map(item => {
                try {
                    // Parse the currency string to object
                    const currencyObj = JSON.parse(item.currency);

                    // Create React Select option
                    return {
                        value: item.id, // Using the item's id as value
                        label: `${currencyObj.label} (${currencyObj.value})` // Format: "Chilean Peso (CLP)"
                    };
                } catch (error) {
                    console.error('Error parsing currency:', error);
                    return null;
                }
            }).filter(option => option !== null); // Remove any null entries from failed parsing

            setCurrencyOpt(currencyOptions)
        })()
    }, [])

    // account type dropdown options
    useEffect(() => {
        (async () => {
            const res = await GetRequest(`masters/fetchAccount_type/${customerId}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                return
            }
            let accountsArr = [];
            res.data && res.data?.map(item => {
                return accountsArr.push({ [item.title]: item.child })
            })
            setAccounts(res.data)
            setAccOptions(accountsArr)
        })()
    }, [])


    const { data: accountsData, refetch, isLoading: accountLoading } = useGetRequest(`masters/fetchChartOfAccount/${customerId}?account_id=${null}`, "fetchAllChartAccData", headers, extras, {})
    useEffect(() => {
        if (!accountsData || accountsData?.length === 0 || accountsData === undefined) setAllProducts([])
        setAllProducts(accountsData?.data)
    }, [accountsData])

    // useeeffect for fetching the listing 
    useEffect(() => {
        (
            async () => {
                try {
                    const res = await GetRequest(`masters/fetchChartOfAccount/${customerId}?account_id=${editAccId || ""}`, { headers }, extras)
                    if (res.status === "fail" || res.success === false) {
                        // toast.error(res.message)
                        return
                    }
                    const options = res.data && res.data.map(item => {
                        return { value: item.id, label: item.account_name, account_code: item.account_code }
                    }).filter(item => item.value !== editAccId)

                    setParentOptions(options)
                } catch (error) {
                    return
                }
            })()
    }, [isEditMode])

    useEffect(() => {
        (async () => {
            if (editAccId === null) return
            const res = await GetRequest(`masters/fetchChartOfAccountByID/${customerId}/${editAccId}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                toast.error(res.message)
                return
            }
            const data = res.data
            setAccType(data.title)

            reset({
                account_type: data.account_type_id,
                ...data
            })
            const item = accounts.flatMap(item => item?.child).find(item => item.id === data.account_type_id)
            setSelectedItem(item)
            setIsEditMode(true)
            setCreateAcc(true)
        })()
    }, [editAccId])


    const handleConfirmedDelete = async () => {
        setLoading(true)
        try {
            if (deleteId === null) return

            const res = await DeleteRequest(`masters/deleteChartOfAccount/${customerId}/${deleteId}/${userID}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                setLoading(false)
                toast.error(res.message)
                setShowDeleteModal(false)
                return
            }
            setLoading(true)
            toast.success(res.message)
            refetch()
            setShowDeleteModal(false)
        } catch (error) {
            return
        }
    }

    const onSubmit = async (data) => {
        try {

            setIsCreating(true)
            const payload = {
                customer_id: customerId,
                user_login_id: userID,
                ...data,
                account_number: accType.toLowerCase() === "bank" ? data.account_number : null,
                ifsc: accType.toLowerCase() === "bank" ? data.ifsc : null,
                currency_id: accType.toLowerCase() === "bank" ? data.currency_id : null,
                // location: z.string().optional(),
                bank_name: accType.toLowerCase() === "bank" ? data.bank_name : null,
                account_type_id: data.account_type,
                account_id: editAccId || null,
                parent_id: data.parent_id === undefined ? null : data.parent_id
            }
            let res;
            if (!isEditMode) {
                res = await PostRequest('masters/createChartOfAccountant/', payload, false, { headers }, extras)
            } else {
                res = await PutRequest(`masters/updateChartOfAccountant/`, payload, { headers }, extras)
            }
            if (res.status === "fail" || res.success === false) {
                setIsCreating(false)
                return
            }
            setIsCreating(false)
            setIsEditMode(false)
            setEditAccId(null)
            setCreateAcc(false)
            setSelectedItem(null)
            refetch()
            reset({
                account_code: "",
                account_name: "",
                account_type: "",
                parent_id: "",
                description: "",
                account_number: "",
                ifsc: "",
                currency_id: '',
                bank_name: ''
            })
            toast.success(res.message)
        } catch (error) {
            setIsCreating(false)
            return
        }
    }

    return (
        <div className="container-fluid p-3 product-container mb-5">

            <div className="d-flex justify-content-between align-items-center gap-3  mb-3">
                <div style={{ width: "80%", paddingRight: "20px" }}>
                    <h5 className="fw-semibold mb-1">Chart Of Accounts</h5>
                    <p className="text-muted small">
                        Record and Track your business expenditures and get the custom
                        reports.
                    </p>
                </div>
                <div className="d-flex align-items-center gap-2">
                    {/* list and tree structure view */}
                    <div className="px-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 5,
                            border: "1px solid #7a3a5e69",
                            borderRadius: "3px",
                            background: "#ffffff",
                            padding: "4px 8px",
                        }}
                    >
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("tree");
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "tree" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                                ":hover": {
                                    backgroundColor: "#f0f0f0",
                                },
                            }}
                        >
                            <IconHierarchy3
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "tree" ? "#212121" : "#212121", // Change color when active
                                }}
                            />
                        </div>
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("list");
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor:
                                    currView === "list" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconLayout2
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "list" ? "#212121" : "#212121", // Change color when active
                                }}
                            />
                        </div>

                    </div>
                    <Button className="btn btn-default d-flex align-items-center gap-1" onClick={() => {
                        if (!masterGrant?.isCreate) {
                            toast.warning("You are not authorized for this action!")
                            return
                        }
                        setCreateAcc(true)
                    }}> Add <IconPlus style={{ width: '16px', height: '16px' }}></IconPlus></Button>
                    {/* <Dropdown>
                        <Dropdown.Toggle className=" btn btn-default no-arrow" style={{ display: "flex", alignItems: "center", paddingRight: "7px" }}>
                            Action
                            <i class="bx bx-chevron-down" style={{ fontSize: "21px" }}></i>
                        </Dropdown.Toggle>
                         <Dropdown.Menu>
                            <Dropdown.Item>Import</Dropdown.Item>
                            <Dropdown.Item>Export</Dropdown.Item>
                            <Dropdown.Item>Copy from Other</Dropdown.Item>
                            <Dropdown.Item>SVC Data</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>  */}
                </div>
                <Button className="btn btn-default-outline d-flex" onClick={() => navigate(-1)}>
                    <BsArrowLeft className="me-1" /> Back
                </Button>
            </div>

            <hr
                className="mb-4"
                style={{ borderTop: "0.5px solid #6c757d", opacity: "0.3", marginTop: "0.7rem" }}
            />
            {
                masterGrant?.isView ?
                    currView === "list" &&
                    <Container
                        fluid
                        style={{
                            fontFamily: "'Poppins', sans-serif",
                            height: "calc(100vh - 10rem)",
                            backgroundColor: "white",
                            padding: 0,
                            animation: "cardEntry 1s ease-out forwards"
                        }}
                        className="mt-3 p-0"
                    >
                        <Table hover responsive className="align-middle container-table" style={{ height: `${allProducts?.length !== 0 && "39rem"}` }}>
                            <thead style={{ backgroundColor: "#f3effe" }}>
                                <tr>
                                    <th className="text-center">S.No</th>
                                    <th className="text-center">Account Name</th>
                                    <th className="text-center">Account Code</th>
                                    <th className="text-center">Account Type</th>
                                    <th className="text-center">Parent Account Name</th>
                                    <th className="text-center"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {allProducts?.length !== 0 ? allProducts?.map((p, idx) => (
                                    <tr key={p?.id}>
                                        <td className="text-center">{idx + 1}</td>
                                        <td className="text-center">{p.account_name}</td>
                                        <td className="text-center">{p.account_code}</td>
                                        <td className="text-center">{p.title || "-"}</td>
                                        <td className="text-center">{p.parent_account_name || "-"}</td>
                                        <td className="lastactionTd" style={styles.lastdStyle}>
                                            <div className="endTdDiv">
                                                <button type="button"
                                                    onClick={(e) => {
                                                        if (!masterGrant?.isEdit) {
                                                            toast.warning("You are not authorized for this action!")
                                                            return
                                                        }
                                                        e.stopPropagation()
                                                        // setSelectedItem({})
                                                        setEditAccId(p.id)
                                                    }} className="btn-default-outline" style={{ height: '28px', width: '28px' }}>
                                                    <i className="fa-solid fa-pencil"></i>
                                                </button>
                                                <button type="button"
                                                    onClick={(e) => {
                                                        if (!masterGrant?.isDelete) {
                                                            toast.warning("You are not authorized for this action!")
                                                            return
                                                        }
                                                        e.stopPropagation()
                                                        setDeleteId(p.id)
                                                        setShowDeleteModal(true)
                                                    }} className="btn-default-outline" style={{ height: '28px', width: '28px' }}>
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                ))
                                    :
                                    <td
                                        colSpan="5"
                                        style={{ textAlign: "center", color: "gray" }}
                                    >
                                        <div
                                            class="d-flex justify-content-center align-items-center"
                                            style={{ position: "absolute", left: "38%", top: "5rem" }}
                                        >
                                            <img
                                                src={nodata}
                                                alt=""
                                                style={{ width: "17rem", marginTop: "0" }}
                                            />
                                        </div>
                                    </td>
                                }
                            </tbody>
                        </Table>
                    </Container>
                    :
                    <>You are not authorized for this action!</>
            }
            {masterGrant?.isView ?
                currView === "tree" &&
                < TreeView data={allProducts}></TreeView>
                :
                <>You are not authorized for this action!</>
            }
            {/* main modal form for creating account */}
            {
                createAcc &&
                <Modal show={createAcc} onHide={() => {
                    setCreateAcc(false)
                    setIsEditMode(false)
                    setEditAccId(null)
                    setSelectedItem(null)
                    reset({
                        account_code: "",
                        account_name: "",
                        account_type: "",
                        parent_id: "",
                        description: "",
                        account_number: "",
                        ifsc: "",
                        currency_id: '',
                        bank_name: ''
                    })
                }} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>  {isEditMode ? "Edit" : "Create New"} Account</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            isCreating &&

                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    zIndex: 1000,
                                    borderRadius: "inherit"
                                }}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                                        <span className="visually-hidden"></span>
                                    </div>
                                    <div className="mt-2 text-primary fw-semibold">
                                        {isEditMode ? "Updating" : "Creating"} Account...
                                    </div>
                                </div>
                            </div>
                        }
                        <Form className="form-container" onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col md={6}>
                                    {/* account type field*/}
                                    <div className="mb-3 focus-z-index position-relative ">
                                        <label className="">
                                            Account Type  <span className="text-danger">*</span>
                                        </label>


                                        <div className="flex position-relative items-center" ref={containerRef} onClick={() => setIsOpen(true)}>
                                            {/* Selected Item Display */}
                                            {selectedItem ? (
                                                <div className="flex-1 position-relative flex items-center justify-between">
                                                    <input
                                                        ref={inputRef}
                                                        type="text"
                                                        className="form-control"
                                                        value={selectedItem.title}
                                                    />
                                                    <div className="d-flex align-items-center">
                                                        <span style={{ height: '26px', backgroundColor: 'black', width: '1px', position: "absolute", right: "34px", top: "12px" }}></span>
                                                        <button
                                                            type="button"
                                                            style={{ position: "absolute", border: "none", backgroundColor: "transparent", right: "8px", top: "14px" }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                clearSelection();
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} style={{ width: '16px', height: '16px' }}></FontAwesomeIcon>
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    {/* Input Field */}
                                                    <input
                                                        ref={inputRef}
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search and select an option..."
                                                        value={inputValue}
                                                        onChange={handleInputChange}
                                                        onFocus={() => setIsOpen(true)}
                                                    />
                                                    <ChevronDown
                                                        className={`w-4 h-4 `}
                                                        style={{ position: "absolute", border: "none", backgroundColor: "transparent", right: "8px", top: "15px", transform: `${isOpen ? 'rotate-180' : ''}`, cursor: "pointer" }}
                                                    />
                                                </>
                                            )}

                                            {isOpen && !selectedItem && (
                                                <div
                                                    ref={dropdownRef}
                                                    style={{
                                                        position: "absolute",
                                                        top: "100%",
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 1000,
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                                        maxHeight: '200px',
                                                        overflowY: "auto",
                                                        fontSize: "14px"
                                                    }}
                                                >
                                                    {isLoading ? (
                                                        <div style={{
                                                            padding: "12px 16px",
                                                            textAlign: "center",
                                                            color: "#666",
                                                            fontSize: "14px"
                                                        }}>
                                                            Loading options...
                                                        </div>
                                                    ) : filteredOptions.length === 0 ? (
                                                        <div style={{
                                                            padding: "12px 16px",
                                                            textAlign: "center",
                                                            color: "#666",
                                                            fontSize: "14px"
                                                        }}>
                                                            No matching options found
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {filteredOptions.map((accObj, index) =>
                                                                Object.entries(accObj).map(([label, accounts]) => (
                                                                    <div key={`${index}-${label}`}>
                                                                        {/* Category header - styled like React Select group headers */}
                                                                        <div style={{
                                                                            padding: "8px 12px",
                                                                            backgroundColor: "#f5f5f5",
                                                                            borderBottom: "1px solid #e6e6e6",
                                                                            fontSize: "12px",
                                                                            fontWeight: "600",
                                                                            color: "#666",
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px",
                                                                            lineHeight: "1.33"
                                                                        }}>
                                                                            {label}
                                                                        </div>

                                                                        {/* Category items */}
                                                                        {accounts.map((acc, accIndex) => (
                                                                            <div
                                                                                key={acc.id}
                                                                                style={{
                                                                                    padding: "8px 12px 8px 24px", // Extra left padding for indentation
                                                                                    cursor: "pointer",
                                                                                    backgroundColor: "transparent",
                                                                                    color: "#212529",
                                                                                    fontSize: "14px",
                                                                                    lineHeight: "1.25",
                                                                                    borderBottom: accIndex === accounts.length - 1 ? "none" : "1px solid #f0f0f0",
                                                                                    transition: "background-color 0.15s ease-in-out",
                                                                                    userSelect: "none",
                                                                                    minHeight: "38px",
                                                                                    display: "flex",
                                                                                    alignItems: "center"
                                                                                }}
                                                                                className="custom-dropdown-option"
                                                                                onClick={() => selectItem(acc)}
                                                                                onMouseEnter={(e) => {
                                                                                    e.target.style.backgroundColor = "#deebff";
                                                                                }}
                                                                                onMouseLeave={(e) => {
                                                                                    e.target.style.backgroundColor = "transparent";
                                                                                }}
                                                                            >
                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    width: "100%"
                                                                                }}>
                                                                                    <div style={{
                                                                                        flex: 1,
                                                                                        minWidth: 0 // Prevents overflow
                                                                                    }}>
                                                                                        <div style={{
                                                                                            fontSize: "14px",
                                                                                            fontWeight: "400",
                                                                                            color: "#212529",
                                                                                            whiteSpace: "nowrap",
                                                                                            overflow: "hidden",
                                                                                            textOverflow: "ellipsis"
                                                                                        }}>
                                                                                            {acc.title}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ))
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                        {errors.account_type && (
                                            <p
                                                className="text-danger mt-1"
                                                style={{ fontSize: "12px" }}
                                            >
                                                {errors.account_type.message}
                                            </p>
                                        )}
                                    </div>
                                    {
                                        errors.account_type &&
                                        <p className="text-danger" style={{ fontSize: '12px' }}>Account Type is Required</p>
                                    }

                                    <style jsx>{`
                                        .custom-dropdown-option:hover {
                                            background-color: #deebff !important;
                                        }
                                        
                                        .custom-dropdown-option:active {
                                            background-color: #2684ff !important;
                                            color: #fff !important;
                                        }
                                    `}</style>

                                    {/* parent account dropdown */}
                                    <Form.Group
                                        className="mb-3 focus-z-index position-relative"
                                        controlId="formAccountType"
                                    >
                                        <Form.Label style={{ marginBottom: 1 }}>
                                            Parent Account
                                        </Form.Label>
                                        <Controller
                                            name="parent_id"
                                            control={control}
                                            rules={{ required: "Account Type is required" }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    options={parent_options}
                                                    placeholder="Select Parent Account"
                                                    classNamePrefix="react-select"
                                                    value={parent_options?.find((opt) => opt.value === field.value) || null}
                                                    onChange={(selected) => {
                                                        const selectedID = selected ? selected.value : null;
                                                        field.onChange(selectedID);
                                                    }}
                                                    components={{
                                                        Option: CustomOption
                                                    }}
                                                    styles={{
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            paddingLeft: '11px',
                                                        }),
                                                    }}
                                                    isClearable
                                                    isSearchable
                                                />
                                            )}
                                        />
                                    </Form.Group>

                                    {/* account name field */}
                                    <Form.Group
                                        className="mb-3 focus-z-index position-relative"
                                        controlId="formAccountName"
                                    >
                                        <Form.Label style={{ marginBottom: 1 }}>
                                            Account Name
                                            <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control {...register('account_name')} type="text" placeholder="Enter Account Name" />
                                        {errors.account_name && (
                                            <p
                                                className="text-danger mt-1"
                                                style={{ fontSize: "12px" }}
                                            >
                                                {errors.account_name.message}
                                            </p>
                                        )}
                                    </Form.Group>


                                    <Form.Group
                                        className="mb-3 focus-z-index position-relative"
                                        controlId="formAccountCode"
                                    >
                                        <Form.Label style={{ marginBottom: 1 }}>
                                            Account Code
                                        </Form.Label>
                                        <Form.Control {...register('account_code')} type="text" placeholder="Enter Account Code" />
                                    </Form.Group>
                                    {selectedItem && selectedItem.title?.toLowerCase() === "bank" && (
                                        <>
                                            {/* Account Number */}
                                            <Form.Group className="mb-3 focus-z-index position-relative" controlId="formAccNumber">
                                                <Form.Label style={{ marginBottom: 1 }}>
                                                    Account Number <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    {...register('account_number')}
                                                    onChange={(e) => {
                                                        setValue('account_number', e.target.value); // Update react-hook-form value
                                                        setAccNo(e.target.value); // Update local state if needed

                                                    }}
                                                    type="text"
                                                    placeholder="Enter Account Number"
                                                />
                                                {errors.account_number && (
                                                    <p className="text-danger mt-1" style={{ fontSize: "12px" }}>
                                                        {errors.account_number.message}
                                                    </p>
                                                )}
                                                {duplicateAccountNumMsg !== null && (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: "12px",
                                                            gap: 2,
                                                            paddingTop: "4px",
                                                            marginBottom: "10px",
                                                        }}
                                                        className="text-danger"
                                                    >
                                                        <IconCircleX stroke={2} style={{ width: "14px", height: "14px" }} />
                                                        {duplicateAccountNumMsg}
                                                    </div>
                                                )}
                                            </Form.Group>

                                            {/* Bank Name */}
                                            <Form.Group className="mb-3 focus-z-index position-relative" controlId="formBankName">
                                                <Form.Label style={{ marginBottom: 1 }}>
                                                    Bank Name <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    {...register('bank_name')}
                                                    type="text"
                                                    placeholder="Enter Bank Name"
                                                />
                                                {errors.bank_name && (
                                                    <p className="text-danger mt-1" style={{ fontSize: "12px" }}>
                                                        {errors.bank_name.message}
                                                    </p>
                                                )}
                                            </Form.Group>

                                            {/* IFSC Code */}
                                            <Form.Group className="mb-3 focus-z-index position-relative" controlId="formAccIfscCode">
                                                <Form.Label style={{ marginBottom: 1 }}>
                                                    IFSC Code <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    {...register('ifsc')}
                                                    type="text"
                                                    placeholder="Enter IFSC Code"
                                                />
                                                {errors.ifsc && (
                                                    <p className="text-danger mt-1" style={{ fontSize: "12px" }}>
                                                        {errors.ifsc.message}
                                                    </p>
                                                )}
                                            </Form.Group>

                                            {/* Currency */}
                                            <Form.Group className="mb-3 position-relative focus-z-index d-flex flex-column" controlId="formCurrency">
                                                <Form.Label style={{ marginBottom: "2px", marginTop: "2px" }} className="fw-lighter">
                                                    Currency
                                                </Form.Label>
                                                <Controller
                                                    name="currency_id"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            options={currencyOpt}
                                                            value={field.value ? currencyOpt.find(option => option.value === field.value) || null : null}
                                                            onChange={(selectedOption) => {
                                                                field.onChange(selectedOption ? selectedOption.value : "");
                                                            }}
                                                            onBlur={field.onBlur}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            classNamePrefix="react-select"
                                                            styles={{
                                                                placeholder: (provided) => ({
                                                                    ...provided,
                                                                    paddingLeft: '11px',
                                                                }),
                                                            }}
                                                            placeholder="Select Currency.."
                                                        />
                                                    )}
                                                />
                                                {errors.currency_id && (
                                                    <p className="text-danger mt-1" style={{ fontSize: "12px" }}>
                                                        {errors.currency_id.message}
                                                    </p>
                                                )}
                                            </Form.Group>
                                        </>
                                    )}
                                    <Form.Group
                                        className="mb-3 focus-z-index position-relative"
                                        controlId="formDescription"
                                    >
                                        <Form.Label style={{ marginBottom: 1 }}>
                                            Description
                                        </Form.Label>
                                        <Form.Control {...register('description')} as={"textarea"} placeholder="Enter Description" />
                                    </Form.Group>
                                </Col>

                                {
                                    watch('account_type') && (
                                        <Col className="position-relative">
                                            {/* Arrow pointing to account type field */}
                                            <div className="position-absolute side-info-tip"></div>

                                            <div className="p-3 rounded side-info">
                                                <h6 className="fw-semibold mb-3">About Account Type</h6>
                                                {accounts.length > 1 &&
                                                    accounts.flatMap(acc => acc?.child || [])
                                                        .filter(item => item?.id === watch('account_type'))
                                                        .map((item, index) => (
                                                            <p key={item.id || index} style={{ color: "white" }} className="small mb-2">
                                                                {item?.description || 'No description available'}
                                                            </p>
                                                        ))
                                                }
                                            </div>
                                        </Col>
                                    )
                                }
                            </Row>
                            <hr
                                className="mb-4"
                                style={{ borderTop: "0.5px solid #6c757d", opacity: "0.3", marginTop: "0.7rem" }}
                            />

                            <div className="d-flex align-items-center gap-2 justify-content-end">
                                <Button className="btn btn-default-outline" onClick={() => {
                                    setCreateAcc(false)
                                    setIsEditMode(false)
                                    setEditAccId(null)
                                    setSelectedItem(null)
                                    reset({
                                        account_code: "",
                                        account_name: "",
                                        account_type: "",
                                        parent_id: "",
                                        description: "",
                                        account_number: "",
                                        ifsc: "",
                                        currency_id: '',
                                        bank_name: ''
                                    })
                                }}>
                                    Close
                                </Button>
                                <Button type="submit" className="btn btn-default">
                                    {isEditMode ? "Update" : "Create"}
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            }
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleConfirmedDelete}
            />
        </div >
    );
};


const styles = {
    lastdStyle: {
        width: 0,
        padding: "0 !important",
        display: "block",
    },
};
